<template>
  <div id="app" class="app">
    <auth-layout v-if="isAuth && !isShareTrip"></auth-layout>
    <layout  v-if="!isAuth && !isShareTrip"></layout>
    <trip-layout v-if="isShareTrip"></trip-layout>
  </div>
</template>

<script>
  import Layout from 'components/layout/Layout'
  import TripLayout from 'components/layout/TripLayout'
  import AuthLayout from 'components/layout/AuthLayout'
  import VuesticPreLoader from 'vuestic-components/vuestic-preloader/VuesticPreLoader.vue'

  export default {
    name: 'app',
    components: {
      VuesticPreLoader,
      AuthLayout,
      Layout,
      TripLayout
    },
    computed: {
      isAuth () {
        let isAuth = this.$route.path.match('auth')
        // console.log('isAuth', isAuth)
        return isAuth
      },
      isShareTrip () {
        let is = this.$route.name
        // console.log('sharedTrip', is, this.$route)
        return (is === 'sharedTrip') || (is === 'driverCard') || (is === 'driverPagos')
      }
    }
  }
</script>

<style lang="scss">
  @import "sass/main";
  body {
    height: 100%;
    #app {
      height: 100%;
    }
  }
  .table>thead>tr>th {
    background-color: white;
    position: sticky;
    // position: -webkit-sticky;
    top: 0;
    z-index: 2;
  } 
</style>



// WEBPACK FOOTER //
// src/App.vue